import Api from './api'

export const getSettingsInfo = async () => {
  const user = await Api.get('/site/settings')
  return user
}
